// extracted by mini-css-extract-plugin
export default {"textWithIcon":"rvKQRViSZb3YpOH3xqrw-TextWithIcon-textWithIcon","reversed":"AvgDO62wZ0v8wDK7mfdg-TextWithIcon-reversed"};